<template>
    <div>
        <!-- <section class="hero is-large find-banner">
            <div class="hero-body">
               
            </div>
        </section> -->
       <MarketingBanner v-if="this.$route.name == 'FindTrip'"/>
       <div v-if="this.$route.name == 'FindTrip'" class="card bottom-margin" style="margin-bottom:30px; padding:30px; background-color:#e8f9ff; box-shadow:none; -webkit-box-shadow:none">
              <div style="max-width:1000px; margin-left: auto; margin-right: auto">
                 <div class="" style="text-align:center; font-size: 1.3em; margin-bottom:15px;">
                    <span v-bind:style="$getTotals()._posts ? 'visibility:visible' : 'visibility:hidden'">
                        <strong class="">Browse {{$getTotals()._posts}} posts from {{$getTotals()._sites}} riders in {{$getTotals()._countries}} countries, and growing fast! </strong>
                    </span>
                </div>
                <span class="" style="font-size:1.1em">We collect and organize links to bike travel posts on personal blogs. Bikepacking or touring, overnight or round-the-world,
                    pavement or dirt, fast or slow, it's all welcome here. Scroll down to explore, or <a href="/share" target="_blank">click here to add a site.</a>
                </span>
              </div>
            </div>
       <!-- <pre>{{resultPages}}</pre> -->


       <!-- *****************TOP*************************** -->
       
        <!-- see scratch.txt for messy attempt at rewriting find UI -->


        <!-- *************BOTTOM***************************** -->

    
        <div class="section" style="padding-top: 30px">
        <div v-if="user && !user.isAnonymous">Logged in as {{user.displayName}} <a @click="signOut">Sign out</a></div>
        <!-- <h1 class="title is-2" id="" style="text-align:center; margin-bottom: 10px">Find Bike Travel Blogs</h1> -->
       
        <div class="container find-trips" style="margin-top:0">
            
            <!-- <span class="explore-here"></span> -->
            <!-- <h1 class="title is-2">Find bike trip journals.</h1> -->
            <!-- <div>{{selectedCountryCode}}</div> -->
            <h2  class="title is-4" id="" style="text-align:center; margin-bottom: 30px">Explore bike travel blogs...</h2>
            <b-tabs class="find-trips-tabs" type="is-boxed"   style="margin-bottom:5px" expanded v-model="activeTab">
                <!-- <b-tab-item label="Region"  icon="globe-africa" class="tab-box is-primary"> -->
                <b-tab-item label="By Region"   class="tab-box is-primary" style="padding:30px;">
                    <div class="">
                        <p class="tab-box-header">Explore by Region</p>
                        <!-- <p style="margin-bottom: 25px; font-size:18px">Explore by continent:</p> -->
                        <b-field  class='taginput continent-chooser wrap has-size-large'>
                            <!-- <div class="block"> -->
                                <b-radio-button v-model="selectedContinent"
                                    native-value="Africa">
                                    <span>Africa</span>
                                </b-radio-button>
                                <b-radio-button v-model="selectedContinent"
                                    native-value="Asia">
                                    <span>Asia</span>
                                </b-radio-button>
                                <b-radio-button v-model="selectedContinent"
                                    native-value="Europe">
                                    <span>Europe</span>
                                </b-radio-button>
                                <b-radio-button v-model="selectedContinent"
                                    native-value="North America">
                                    <span>North America</span>
                                </b-radio-button>
                                <b-radio-button v-model="selectedContinent"
                                    native-value="Oceania">
                                    <span>Oceania</span>
                                </b-radio-button>
                                <b-radio-button v-model="selectedContinent"
                                    native-value="South America">
                                    <span>South America</span>
                                </b-radio-button>
                                <!-- <b-radio-button v-model="selectedContinent"
                                    native-value="All">
                                    <span>All</span>
                                </b-radio-button> -->
                            <!-- </div> -->
                        </b-field>
                        <div style="margin-top:20px">Or, you can <a @click="activeTab = 1">search by country</a></div>
                    </div>
                    
                </b-tab-item>

                <!-- <b-tab-item label="Country"  icon="flag" class="tab-box is-primary"> -->
                <b-tab-item label="By Country"  class="tab-box is-primary" style="padding:30px"> 
                    <p class="tab-box-header">Explore by Country</p>   
                    <CustomTagInput class="" style="max-width: 500px; margin-left: auto; margin-right: auto"
                        v-bind:size = "'is-medium'" 
                        v-bind:placeholder = "'Start typing a country...'" 
                        v-bind:allData = "countryArray"
                        v-bind:field = "'name'"
                        v-bind:type = "'is-success'"
                        v-bind:maxtags = "1"
                        v-bind:maxwidth = "1000"
                        
                        ref = "country-filter-find"
                    />
                    
                    <!-- <pre>{{subregions}}</pre> @changed = "updateCountryChoice"  -->

                    <!-- <p :style="subregions.length > 0 ? 'display:block' : 'display:none'" class="tab-box-header">Filter by State / province (optional)</p>    -->
                    <CustomTagInput  :style="subregions.length > 0 ? 'display:block' : 'display:none'" class="" style="max-width: 500px; margin-left: auto; margin-right: auto; text-align:center"
                        v-bind:size = "'is-medium'" 
                        v-bind:placeholder = "'State / province (optional)...'" 
                        v-bind:allData = "subregions"
                        v-bind:type = "'is-success'"
                        v-bind:maxtags = "1"
                        v-bind:maxwidth = "1000"
                        ref = "subregion-filter-find"
                    />
                    <a v-if="getCountryInput() != ''" style="display:block; margin-top:10px;" @click="setCountryInput('')">new search</a>
                    <div class="autofill-options" v-if="getCountryInput() == ''">
                        <span><strong>Popular:</strong></span>
                        <a @click="setCountryInput('United States')">USA</a>
                        <a @click="setCountryInput('Tajikistan')">Tajikistan</a>
                        <a @click="setCountryInput('Germany')">Germany</a>
                        <a @click="setCountryInput('New Zealand')">New Zealand</a>
                        <a @click="setCountryInput('United Kingdom')">UK</a>
                        <a href="/countries">See all...</a>
                    </div>
                    <!-- <a style="display:inline-block; margin-top: 20px" href="/countries">Go to countries list...</a> -->
                </b-tab-item>

                <!-- <b-tab-item label="Route" icon="route" class="tab-box"> -->
                <b-tab-item label="By Route"  class="tab-box" style="padding:30px;">
                    <p class="tab-box-header">Explore by Route</p>  
                    <CustomTagInput  style="max-width: 500px;  margin-left: auto; margin-right: auto;"
                        v-bind:size = "'is-medium'" 
                        v-bind:placeholder = "'Start typing a route...'" 
                        v-bind:allData = "routes"
                        v-bind:type = "'is-info'"
                        v-bind:maxtags = "1"
                        v-bind:maxwidth = "1400"
                       
                        ref = "route-filter-find"
                    />
                    <a v-if="getRouteInput() != ''" style="display:block; margin-top:10px;" @click="setRouteInput('')">new search</a>
                    <div class="autofill-options" v-if="getRouteInput() == ''">
                        <span><strong>Popular:</strong></span>
                        <a @click="setRouteInput('Cairo to Cape Town')">Cairo to Cape Town</a>
                        <a @click="setRouteInput('Silk Road')">Silk Road</a>
                        <!-- <a @click="setRouteInput('Pamir Highway')">Pamir Highway</a> -->
                        <a @click="setRouteInput('Eurovelo 6')">EuroVelo 6</a>
                        <a @click="setRouteInput('Great Divide Mountain Bike Route')">GDMBR</a>
                        <a href="/routes">See all...</a>
                        <!-- <a @click="setRouteInput('TransAmerica')">TransAmerica</a> -->
                    </div>
                    <!-- <a style="display:inline-block; margin-top: 20px" href="/routes">Go to routes list...</a> -->
                </b-tab-item>
                
            </b-tabs>



            <!-- <pre>{{selectedContinent}}</pre> -->
            <!-- <b-collapse :open="resultPages.length > 0 && showingSelected" aria-id="contentIdForA11y1" v-if="true" position="is-bottom"> -->

            <!-- <b-collapse :open="filtersOpen" class="" position="is-bottom"  aria-id="showFilters"  v-if="!sitePagesMode"> -->
                <!-- <a slot="trigger" slot-scope="props" aria-controls="showFilters" style="margin-top:10px; font-size:20px">
                    <b-icon :icon="!props.open ? 'angle-right' : 'angle-up'"></b-icon>
                    {{ !props.open ? 'Filter by style, surface, and more' : 'Hide filters' }} <span v-if="activeFilterCount > 0">{{"(" + activeFilterCount + " filter" + (activeFilterCount == 1 ? "" : "s") + " applied)"}}</span>
                </a> -->
            <!-- <div v-if="filtersOpen"> -->
                <!-- <pre>{{filtersOpen}}</pre> -->
            <div class='filter-box' style="display:none" v-bind:class="filtersOpen ? 'shown' : ''">
               <div class="container" >
                    <div class="content box">
                        
                        <div class="columns">
                            <div class="column is-one-third">
                                 <div class="">  <!-- MOOD -->
                            <strong>Style</strong>
                            <b-tooltip
                                label="Here we use 'touring' to refer to trips with more pavement, panniers, and towns, while 'bikepacking' refers to more minimalist gear on remote and/or off-pavement routes. We acknowledge there is some overlap!"
                                multilined type="is-light" size="is-large">
                                <button class="button tooltip-trigger" style="padding:0 0 0 5px; background-color: transparent; border: none" type="button">
                                    <b-icon class="tooltip-icon"
                                        pack="fas"
                                        icon="question-circle"
                                        size="is-small"
                                    >
                                    </b-icon>
                                    
                                    </button>
                                </b-tooltip>
                                <b-field class='taginput wrap'>
                                    <b-checkbox-button v-model="selectedStyles" type="is-light"
                                        native-value="touring">
                                        <span>Touring</span>
                                    </b-checkbox-button>
                                    <b-checkbox-button v-model="selectedStyles"  type="is-light"
                                        native-value="bikepacking">
                                        <span>Bikepacking</span>
                                    </b-checkbox-button>
                                   
                                </b-field>
                            </div>
                            
                        </div>

                        <div class="column is-two-thirds">
                                <strong>Extras</strong>
                                <b-field class='taginput wrap'>
                                    <b-checkbox-button v-model="selectedExtras" type="is-light"
                                        native-value="short">
                                        <span>Short (2-5 days)</span>
                                    </b-checkbox-button>
                                    <b-checkbox-button v-model="selectedExtras"  type="is-light"
                                        native-value="map">
                                        <span>Has Map</span>
                                    </b-checkbox-button>
                                    <b-checkbox-button v-model="selectedExtras"  type="is-light"
                                        native-value="video">
                                        <span>Has Video</span>
                                    </b-checkbox-button>
                                   
                                </b-field>
                            </div>
                            
                        </div>


                        <div class="top-margin">  <!-- RIDING -->
                            <strong>Roads and Trails</strong>
                            <b-field class='taginput wrap'>
                                <!-- <b-field class='taginput wrap' :input="filterUpdated('surface')"> -->
                                <!-- <div class="block"> -->
                                    <b-checkbox-button v-model="selectedSurfaces" type="is-light"
                                        native-value="pavement">
                                        <span>Pavement</span>
                                    </b-checkbox-button>
                                    <b-checkbox-button v-model="selectedSurfaces"  type="is-light"
                                        native-value="gravel">
                                        <span>Gravel</span>
                                    </b-checkbox-button>
                                    <b-checkbox-button v-model="selectedSurfaces" type="is-light"
                                        native-value="dirt">
                                        <span>Dirt</span>
                                    </b-checkbox-button>
                                    <b-checkbox-button v-model="selectedSurfaces" type="is-light"
                                        native-value="singletrack">
                                        <span>Singletrack</span>
                                    </b-checkbox-button>
                                    <b-checkbox-button v-model="selectedSurfaces" type="is-light"
                                        native-value="bike paths">
                                        <span>Bike Paths</span>
                                    </b-checkbox-button>
                                    <b-checkbox-button v-model="selectedSurfaces" type="is-light"
                                        native-value="low traffic">
                                        <span>Low Traffic</span>
                                    </b-checkbox-button>
                                    <b-checkbox-button v-model="selectedSurfaces" type="is-light"
                                        native-value="hilly">
                                        <span>Hilly</span>
                                    </b-checkbox-button>
                                    <b-checkbox-button v-model="selectedSurfaces" type="is-light"
                                        native-value="flat">
                                        <span>Flat</span>
                                    </b-checkbox-button>
                                <!-- </div> -->
                            </b-field>
                        </div>

                        <div class="top-margin"> <!-- MOOD -->
                        <strong>Filter by Mood</strong>
                        <b-field class='taginput wrap'>
                                <b-checkbox-button v-model="selectedMoods" type="is-light"
                                    native-value="populated">
                                    <span>Populated</span>
                                </b-checkbox-button>
                                <b-checkbox-button v-model="selectedMoods" type="is-light"
                                    native-value="remote">
                                    <span>Remote</span>
                                </b-checkbox-button>
                                <b-checkbox-button v-model="selectedMoods" type="is-light"
                                    native-value="challenging">
                                    <span>Challenging</span>
                                </b-checkbox-button>
                                <b-checkbox-button v-model="selectedMoods" type="is-light"
                                    native-value="relaxing">
                                    <span>Relaxing</span>
                                </b-checkbox-button>
                               
                        </b-field>
                    </div>
                         
                        <div class="top-margin"> <!-- RIDERS -->
                            <strong>Rider Tags</strong>
                            <div class="hint">Type to search user-created tags, for example: person of color, solo female, over 65, or family.</div>
                            <CustomTagInput style="max-width: 700px;"
                                v-bind:label = "''" 
                                v-bind:size = "'is-medium'" 
                                v-bind:type = "'is-light'" 
                                v-bind:placeholder = "'Type to search'" 
                                v-bind:allData = "riderTags"
                                v-bind:allowNew = "false"
                                v-bind:openOnFocus = "true"
                                ref = "rider-tags-find"
                                @changed="filterUpdated('rider')"
                            />
                        </div>


                        <!-- VIDEO FILTERS -->
                        <!-- <div class="top-margin type-selector">
                            <strong>Include: </strong>
                             <b-field class='taginput wrap'>
                               
                                    <b-checkbox v-model="selectedContentTypes"
                                        native-value="blog">
                                        <span>Blogs</span>
                                    </b-checkbox>
                                    <b-checkbox v-model="selectedContentTypes"
                                        native-value="video">
                                        <span>Videos</span>
                                    </b-checkbox>
                                  
                            </b-field>
                        </div> -->
                        <div class="hint top-margin"><br>All filters are "and" combinations, meaning a post must be tagged with ALL choices in order to show. If you're not seeing enough results, try <a @click="clearFilters()">removing filters</a>.</div>
                    </div>
                    </div>
                    
                </div>
                
                 <a @click="filtersOpen = !filtersOpen" style="margin-top:0px; font-size:16px; float:left; display:none" class="filter-toggle" v-bind:class="showingSelected ? 'visible' : 'hidden'">
                    <b-icon :icon="!filtersOpen ? 'angle-right' : 'angle-up'"></b-icon>
                    {{ !filtersOpen ? 'Show more filters' : 'Hide filters' }} <span v-if="activeFilterCount > 0">{{"(" + activeFilterCount + " applied)"}}</span>
                </a>
                <span v-if="activeFilterCount > 0" style="margin-top:0px; font-size:16px; float:right"><a @click="clearFilters()"  >Clear filters</a></span>
                
            <!-- </b-collapse> -->
       <!-- <pre>{{resultPages.length}}</pre><pre> showing {{visibleResultCount}}</pre><pre> hiding {{hiddenResultCount}}</pre> -->
         <!-- <pre>{{selectedContinent}}</pre> -->
        <div ref="pageList" style="margin-top:60px">
        <!-- <pre>{{resultPages}}</pre> -->
        <div class="existing-pages" v-if="resultPages">
            <!-- <div>{{showingSelected ? '' : "Use the search and filter box above to find specific journals, or just see what's new:"}}</div> -->
            <h2 style="text-align:center; margin-bottom:35px">
                <span id="results-title" style="margin-bottom:5px; display:block; margin-top:5px" class="title is-size-2">{{showingSelected ? filteredHeading : 'Recently Added'}}</span> 
                <span  style="text-transform:uppercase; font-size:17px; font-weight:bold; display:block; margin-bottom:5px">{{details && details.bikepacking ? "Bikepacking Trip Reports" : "Touring & Bikepacking Blogs"}} </span>
                <!-- <span v-if="resultPages[0].approved_on" style="font-size:14px; font-weight:normal; display:block; ">Last update: {{getPrettyDate(resultPages[0].approved_on.toDate())}}</span> -->
                <span  v-if="resultPages.length > 0" style="font-size:14px; font-weight:normal; display:block; ">Last update: {{getMostRecentDate()}}</span>
                <!-- <span style="width:200px; display:block; border-bottom: 2px solid black; margin-left:auto; margin-right:auto; margin-bottom:30px"></span> -->
            </h2>
            
            
            <!-- INTRO BLURB -->
            <div v-if="details && details.intro && details.intro != ''" class="intro" style="margin-bottom: 30px" >
                <p v-html="details.intro"></p>
            </div> 



            <!-- <p class="has-text-success" style="font-weight:bold; margin-bottom: 20px">{{resultPages.length}} bicycle blog entries</p>  -->
            <!-- <p>{{getListLength()}}</p> -->
            <!-- <h3 class="title is-4 top-margin">{{showingSelected ? '' : 'Recently Added'}}</h3>   -->
            <div ref="resultCards">
            <div 
                v-for="(page, idx) in this.resultPages"
                v-bind:key = page.id 
                >
                <PageResult 
                    :page = "page"
                    :approveMode = "false"
                    :ref="passesAllFilters(page, (idx == resultPages.length - 1)) ? 'visibleCard' : 'invisibleCard'"
                    :class="passesAllFilters(page, (idx == resultPages.length - 1)) ? 'visible' : 'hidden'"
                    :showYear="showingSelected ? true : false"
                />
     
                
            </div>
                
            </div>
        </div>
        </div>
        <div class="section card" ref="results" v-if="isLoading">
            <b-icon class="fas fa-spinner fa-spin"></b-icon>
            
            Loading...</div>
        <div v-if="resultPages.length == 0 && !isLoading"  class="section card">
            <p style="text-align:center">None yet :(   You can <router-link to="/share" style="font-weight:normal; text-decoration:underline">add some</router-link> if you'd like!</p>
        </div>
        <div v-if="activeFilterCount > 0 && resultPages.length > 0" style="padding: 30px 0px; font-size: 18px; text-align:center">Viewing filtered results. To see more, <a v-on:click="clearFilters">click here to clear filters.</a></div>
        </div>
        <!-- <b-button @click="nextPage" >Next page</b-button> -->
        <!-- <b-button @click="nextPage" v-scroll-to="'#result-last'">Next page</b-button> -->
        <b-button type="is-primary" v-if="!noMorePages && resultPages.length > 0" @click="nextPage" v-scroll-to="{
            el:'#result-last',
            easing:'ease',
            offset: -100
        
        }">Load more</b-button>
        <!-- <div v-if="activeFilterCount > 0" style="padding: 30px 0px; font-size: 18px; text-align:left">To see more results, <a v-on:click="clearFilters">click here to clear filters</a></div> -->
        <b-button v-if="resultPages.length > 0" v-scroll-to="'#app'">Scroll to top</b-button>
        <SocialSharePrompt :headerText="filteredHeading != '' ? filteredHeading : 'BikeSleepBike'" :location="'side'"/>
        
        <!-- <div style="margin-top:30px; margin-bottom:20px; text-align:center"><p style="font-weight:bold">Add to the collection! Submit links to bike travel journals <a style="text-decoration:underline; " href="/share" >right here.</a></p></div> -->
        </div>
    </div>  
</template>

<script>
// import {allcountries} from "../data.js";
import CustomTagInput from '@/components/CustomTagInput';
import MarketingBanner from '@/components/MarketingBanner';
import SocialSharePrompt from '@/components/SocialSharePrompt';
import FormPopup from '@/components/FormPopup';
import PageResult from '@/components/PageResult';

import Router from 'vue-router'
const { isNavigationFailure, NavigationFailureType } = Router
export default {
    name: 'FindTrip',
    components: {CustomTagInput, MarketingBanner, SocialSharePrompt, FormPopup, PageResult},
    data () {
        return {
            // pages:{},
            // countries:{},
            // allcountries:allcountries,
            filtersOpen: false,
            selectedContentTypes: ['blog','video'], // if adding more, change number in getFilterCount and update passesAllFilters and clearFilters
            // selectedCountries: [],
            // filteredCountries: [],
            resultPages:[],
            showingSelected:false,

            selectedSurfaces: [],
            selectedMoods: [],
            selectedStyles: [],
            selectedExtras: [],
            // selectedSubregion: "",
            routes: [],
            subregions: [], // populates with all subregions once country is selected
            riderTags: [],
            initDataLoaded: false,
            activeTab: 0,
            selectedContinent: "",

            filteredHeading: "",
            // selectedCountryCode: "",
            // selectedRoute: "",
            currentQuery: undefined,
            passedFilterCount: 0,
            lastVisibleResult: undefined,
            queryLimit: 20,
            noMorePages: false,
            isPaginated: false,
            activeFilterCount: 0,
            details: undefined,
            isLoading: false,
            visibleResultCount: 0,
            hiddenResultCount: 0,
            isMounted: false,
            displayTextMap: { Transamerica: "TransAmerica" , 'Pan-american Highway': "Pan-American Highway"}
            // debug: false
        }
    
    },

    watch: {
        
        // selectedSubregion: function(newSubregion, oldSubregion) {
        //     console.log("selectedSubregion called with new, old: ", newSubregion, " , ", oldSubregion);
        //     if (newSubregion != "" && newSubregion != undefined && newSubregion != oldSubregion) {
        //         this.fetchPagesBySubregion(this.selectedSubregion);
        //         this.filteredHeading = this.$countrymap[this.selectedCountryCode] + ": " + this.selectedSubregion;
        //         var newPath = '/countries/' + this.$countrymap[this.selectedCountryCode].toLowerCase() + "/" + this.selectedSubregion.toLowerCase();
                
        //         if (this.$route.path != newPath) {
        //             // console.log("changing route");
        //             this.$router.push({ path: newPath}).catch(failure => {
        //             // if (isNavigationFailure(failure, NavigationFailureType.duplicated)) {
        //             //     // show a small notification to the user
        //             // }
        //             });
        //         }

        //         this.loadItemDetails(newSubregion, 'regions');

        //         //reset other things as needed (this part is messy logic having to do with which combos of search I'm choosing to allow)
        //         this.selectedContinent = "";
        //         // this.selectedRoute = "";
        //         this.$refs["route-filter-find"].selectedModel[0] = [];

                
        //     } else if (newSubregion == "" && this.selectedCountryCode != "") { 
        //         this.fetchPagesByCountry(this.selectedCountryCode);
        //         this.filteredHeading = this.$countrymap[this.selectedCountryCode];
        //         var newPath = '/countries/' + this.$countrymap[this.selectedCountryCode].toLowerCase();
        //         if (this.$route.path != newPath) {
        //             this.$router.push({ path: newPath}).catch(failure => {
        //             // if (isNavigationFailure(failure, NavigationFailureType.duplicated)) {
        //             //     // show a small notification to the user
        //             // }
        //             });
        //         }
        //         // this.setCountryInput(this.$countrymap[this.selectedCountryCode]);
        //     }
        // },
        selectedSurfaces: function(newSurfaces, oldSurfaces) {
            this.filterUpdated('surface');
        },
        selectedMoods: function(newMoods, oldMoods) {
            this.filterUpdated('mood');            
        },
        selectedStyles: function(newStyles, oldStyles) {
            this.filterUpdated('style');            
        },
        selectedExtras: function(newStyles, oldStyles) {
            this.filterUpdated('extras');            
        },
        selectedContentTypes: function(newTypes, oldTypes) {
            this.filterUpdated('content');
        },
        resultPages: function(newResults, oldResults) {
            // console.log("resultPages changed");
            // this.visibleResultCount = 0;

            // PROBLEM: this only fires when new results are fetched, not when filters are updated without fetching new data. Fix by putting results in separate component and running this each time it's finished rerendering?
            this.$nextTick(function() {
                // console.log(this.$refs['visibleCard'] );
                if (this.$refs['visibleCard']) {
                    this.visibleResultCount = this.$refs['visibleCard'].length; 
                }
                if (this.$refs['invisibleCard']) {
                    this.hiddenResultCount = this.$refs['invisibleCard'].length;
                }
                
                 
            });
        
            
        }
    },
    computed: {
       countryArray: function() {
            // console.log(this.allcountries);
            if (this.$countrymap) {
                // console.log(this.allcountries);
                var tosave = [];
                for (const prop in this.$countrymap) {
                    var elem = {code:prop, name:this.$countrymap[prop]};
                    tosave.push(elem);
                }
                return tosave;
            } else {
                return [];
            }
       },
        user: function() {
            return this.$getParent('App').user;
            // return this.$firebase.auth().currentUser;
        }
    },
    methods: {
        getPrettyDate(date) {
            var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            if (date) {
                return months[date.getMonth()] + " " + date.getDate() + " " + date.getFullYear();
            } else {
                return "";
            }
            
        },
        getMostRecentDate() {
            var latest = new Date(0,0,0);
            for (var i in this.resultPages) {
                var page = this.resultPages[i];
                if (page.approved_on && page.approved_on.toDate() > latest) {
                    latest = page.approved_on.toDate()
                } else if (page.added && page.added.toDate() > latest) {
                    latest = page.added.toDate();
                }
                
            }
            return this.getPrettyDate(latest);
        },
        fetchSubregionsByCountry(code) {
            var that = this;
            this.$db.collection('regions').doc(code).get()
                .then(function(doc) {
                    if (doc.exists) {
                        console.log(doc.data());
                        that.subregions = doc.data().regions;
                    } else {
                        that.subregions = [];
                    }

                }).catch(function(error) {
                    console.log("Error getting subregions for country ", code, error);
                })
        },
        loadItemDetails(name, type) {  // get intro, other stuff
            // console.log("loadItemDetails called with ", name);
            // console.log(name);
            var that = this;
            var text = "";
            this.$db.collection(type).where("display_name", "==", name).get()
                .then(function(querySnapshot) {
                    if (querySnapshot.size == 0) {
                        that.details = undefined;
                    } else {
                        querySnapshot.forEach(function(doc) { // looks like loop but should always only be 1 item
                            that.details = doc.data();
                        });
                    }
                })
                .catch(function(error) {
                    console.log("Error getting details for: ", name, " - ", error);
                });
        },
        clearFilters() {
            if (this.$debug) {console.log("DEBUG: In function clearFilters");}
            this.selectedMoods = [];
            this.selectedStyles = [];
            this.selectedSurfaces = [];
            this.selectedExtras = [];
            // this.riderTags = [];
            // this.$refs["rider-tags-find"].selectedModel = [];
            this.$refs["rider-tags-find"].setModel([]);

            this.activeFilterCount = 0;
            this.filtersOpen = false;
            this.selectedContentTypes = ['blog','video'];
        },
        filterUpdated(filterType) {
            if (this.$debug) {console.log("DEBUG: In function filterUpdated with input filterType=", filterType);}
            this.$analytics.logEvent('filter_updated', { value: filterType});
            // console.log(filterType + " filter changed");
            // this.queryLimit = 100;
            // this.nextPage();
            // this.filtersOpen = true;
            this.activeFilterCount = this.getFilterCount();
            // switch into non-paginated mode if any filters activated, or back if none
            if (this.activeFilterCount == 0) {
                this.queryLimit = 20;
            } else {
                this.queryLimit = 200;
                this.nextPage();
            }


            var query = {};
            //update URL query params
            if (this.selectedMoods.length > 0) {
                query.mood = this.selectedMoods.join(",");
            }
            if (this.selectedStyles.length > 0) {
                query.style = this.selectedStyles.join(",");
            }
             if (this.selectedExtras.length > 0) {
                query.extras = this.selectedExtras.join(",");
            }
            if (this.selectedSurfaces.length > 0) {
                query.surface = this.selectedSurfaces.join(",");
            }
            if (this.$refs["rider-tags-find"] && this.$refs["rider-tags-find"].selectedModel.length > 0) {
                query.rider = this.$refs["rider-tags-find"].selectedModel.join(",");
                // this.getFilterCount();
            }
            if ("scroll" in this.$route.query) {
                query.scroll = this.$route.query.scroll;
            }
            console.log("Query", query);
            var baseUrlWithOutHash = window.location.origin + window.location.pathname;
            
            if (Object.keys(query).length > 0) {
                
                var hash = window.location.hash;
                var newurl = baseUrlWithOutHash + "?" + this.createQueryString(query) + hash;
                console.log("pushing newurl", newurl)
                window.history.replaceState({path:newurl},'',newurl);
            } else {
                window.history.replaceState({path:baseUrlWithOutHash},'',baseUrlWithOutHash);
                console.log("pushing plain url", baseUrlWithOutHash);
            }
            
            
            

            // const { isNavigationFailure, NavigationFailureType } = this.$router;
            // if (this.$route.query != query) {
            // this.$router.push({ query: query}).catch(failure => { });
                // if (isNavigationFailure(failure, NavigationFailureType.duplicated)) {
                //     // show a small notification to the user
                // }
                
            // }
            

        },

        getFilterCount() {
            if (this.$debug) {console.log("DEBUG: In function getFilterCount");}
            var count = 0;
            if (this.selectedMoods.length > 0) { count++ }
            if (this.selectedStyles.length > 0) { count++ }
            if (this.selectedExtras.length > 0) { count++ }
            if (this.selectedSurfaces.length > 0) {count++ }
            if (this.$refs["rider-tags-find"] && this.$refs["rider-tags-find"].selectedModel.length > 0) { count++ }
            if (this.selectedContentTypes.length < 2) {count++ }
            // console.log(this.selectedContentTypes.length);
            return count;
        },

        createQueryString(query) {
            if (query != {}) {
                
                var querystring = "";
                for (var i in Object.keys(query)) {
                    var key = Object.keys(query)[i];
                    if (i > 0) {
                        querystring = querystring + "&";
                    }
                    querystring = querystring + key + "=" + query[key];
                }
                // for (var key in query) {
                //     // var vals = query[key].split();
                //     querystring = querystring + "&" + key + "=" + query[key];
                // }
                return querystring;
            } else {
                return "";
            }
            
        },

        getMainQueryCount() {
             that.$db.collection("counts").doc("totals").get()
                        .then(function(doc) {
                            
                            if (doc.exists){
                                console.log(doc.data());
                                that.totals = doc.data();
                            }
                        }).catch(function(error) {
                            console.error("Error fetching totals: ", error);
                        });
        },

        passesAllFilters(pageData, isLast) {
            // if (!this.sitePagesMode) {
                var isSurfaceMatch = true;
                for (var i = 0; i < this.selectedSurfaces.length; i++) {
                    if (!pageData.surfaces.includes(this.selectedSurfaces[i])) {
                        // not a match
                        isSurfaceMatch = false;
                        break;
                    }
                }
                var isMoodMatch = true;
                for (var i = 0; i < this.selectedMoods.length; i++) {
                    if (!pageData.mood.includes(this.selectedMoods[i])) {
                        isMoodMatch = false;
                        break;
                    }
                }

                var isStyleMatch = false;
                if (this.selectedStyles.length == 0) {
                    isStyleMatch = true;
                }
                if (pageData.touring && this.selectedStyles.includes("touring")) {
                    isStyleMatch = true;
                }
                 if (pageData.bikepacking && this.selectedStyles.includes("bikepacking")) {
                    isStyleMatch = true;
                }

                var isExtrasMatch = true;
                this.selectedExtras.forEach(function(extra) {
                    if (!pageData[extra]) {
                        isExtrasMatch = false;
                    }
                });


                var isRiderMatch = true;
                if (this.$refs["rider-tags-find"]) {
                     var selectedRiders = this.$refs["rider-tags-find"].selectedModel;
                for (var i = 0; i < selectedRiders.length; i++) {
                    if (!pageData.ridertags.includes(selectedRiders[i])) {
                        isRiderMatch = false;
                        break;
                    }
                }
                }
               

                var isTypeMatch = true;
                if (!this.selectedContentTypes.includes("blog")) { // we want to exclude blogs
                    if (pageData.content_type == undefined || pageData.content_type == "blog") {
                        // it's a blog
                        isTypeMatch = false;
                    } 
                }
                if (!this.selectedContentTypes.includes("video")) { // exclude videos
                    if (pageData.content_type == "video") {
                        // it's a video
                        isTypeMatch = false;
                    } 
                }

                if (isMoodMatch && isSurfaceMatch && isRiderMatch && isTypeMatch && isStyleMatch && isExtrasMatch) {
                    // filteredResultPages.push(page);
                    return true;
                } else {
                    return false;
                }
        },

        
        sorted(array) {
            return array.sort();
        },
      
        fetchPagesByContinent(continent) {
            if (this.$debug) {console.log("DEBUG: In function fetchPagesByContinent");}
            
            if (continent != "") { // GET FILTERED
                this.$analytics.logEvent('fetch_results', { type: 'continent', value: continent});
                this.isLoading = true;
                var that = this;
                var result = [];
                this.noMorePages = false;
                this.lastVisibleResult = undefined;
                this.currentQuery = this.$db.collection("pages").where("continent", "==", continent).orderBy("year", "desc").orderBy("added", "desc");
                this.$db.collection("pages").where("continent", "==", continent).orderBy("year", "desc").orderBy("added", "desc").limit(that.queryLimit).get()
                    .then(function(querySnapshot) {
                        querySnapshot.forEach(function(doc) {
                            // doc.data() is never undefined for query doc snapshots
                            var dataAndId = doc.data();
                            dataAndId['id'] = doc.id;
                            result.push(dataAndId);
                        
                        });
                        that.lastVisibleResult = querySnapshot.docs[querySnapshot.docs.length - 1];
                        if (!that.lastVisibleResult || querySnapshot.docs.length < that.queryLimit ) {
                            that.noMorePages = true;
                        }
                        that.resultPages = result;
                        that.showingSelected = true;
                        that.isLoading = false;
                    })
                    .catch(function(error) {
                        console.log("Error getting pages by continent: ", error);
                        that.isLoading = false;
                    });
                this.showingSelected = true;
            } else { // GET ALL
                // this.selectedContinent = "";
                // this.getRecentlyAdded();
            }
        },
        fetchPagesByCountry(countryCode) {
            // if (this.$debug) {console.log("DEBUG: In function fetchPagesBycountry with name ", countryName);}
            // var countryCode = this.getCodeFromCountry(countryName);
            if (this.$debug) {console.log("DEBUG: In function fetchPagesBycountry with code ", countryCode);}
            this.$analytics.logEvent('fetch_results', { type: 'country', value: countryCode});
            this.isLoading = true;
            // this.clearFilters();
            var that = this;
            var result = [];
            this.noMorePages = false;
            this.lastVisibleResult = undefined;
            // var queryLimit = this.pageSize;
            // if (this.activeFilterCount > 0) { //override pagination if filters are being used (hack for now because firebase sucks at tag filtering)
            //     queryLimit = 1000;
            // }
            this.currentQuery = this.$db.collection("pages").where("countries", "array-contains", countryCode).orderBy("year", "desc").orderBy("added", "desc");
            this.$db.collection("pages").where("countries", "array-contains", countryCode).orderBy("year", "desc").orderBy("added", "desc").limit(that.queryLimit).get()
                .then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        // doc.data() is never undefined for query doc snapshots
                        // console.log(doc.id, " => ", doc.data());
                        var dataAndId = doc.data();
                        dataAndId['id'] = doc.id;
                        result.push(dataAndId);
                    
                    });
                    that.lastVisibleResult = querySnapshot.docs[querySnapshot.docs.length - 1];
                    if (!that.lastVisibleResult || querySnapshot.docs.length < that.queryLimit ) {
                        that.noMorePages = true;
                    }
                    that.resultPages = result;
                    that.showingSelected = true;
                    that.isLoading = false;
                })
                .catch(function(error) {
                    console.log("Error getting pages by country: ", error);
                    that.isLoading = false;
                });
            this.showingSelected = true;
            
        },
        fetchPagesByRoute(newRoute) {
            if (this.$debug) {console.log("DEBUG: In function fetchPagesByRoute");}
            this.$analytics.logEvent('fetch_results', { type: 'route', value: newRoute});
            this.isLoading = true;
            var that = this;
            var result = [];
            this.noMorePages = false;
            this.lastVisibleResult = undefined;
           
            // if (this.displayTextMap[newRoute]) {
            //     this.setRouteInput(this.displayTextMap[newRoute]);
            //     // cleanedRoute = this.displayTextMap[this.$refs["route-filter-find"].selectedModel[0]];
            // }
            if (this.$debug) {console.log("*** Getting pages for ", newRoute);}
            this.currentQuery = this.$db.collection("pages").where("routes", "array-contains", newRoute).orderBy("year", "desc").orderBy("added", "desc");
            this.$db.collection("pages").where("routes", "array-contains", newRoute).orderBy("year", "desc").orderBy("added", "desc").limit(that.queryLimit).get()
                .then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        // doc.data() is never undefined for query doc snapshots
                        // console.log(doc.id, " => ", doc.data());
                        var dataAndId = doc.data();
                        dataAndId['id'] = doc.id;
                        if (!result.includes(doc.id)) {
                            result.push(dataAndId);
                        }
                    });
                    that.lastVisibleResult = querySnapshot.docs[querySnapshot.docs.length - 1];
                    if (!that.lastVisibleResult || querySnapshot.docs.length < that.queryLimit ) {
                        that.noMorePages = true;
                    }
                    that.resultPages = result;
                    that.showingSelected = true;
                    that.isLoading = false;
                })
                .catch(function(error) {
                    console.log("Error getting pages by route: ", error);
                    that.isLoading = false;
                });
            this.showingSelected = true;
        },
        fetchPagesBySubregion(subregion) {
            if (this.$debug) {console.log("DEBUG: In function fetchPagesBySubregion, subregion is ", subregion);}
            this.$analytics.logEvent('fetch_results', { type: 'subregion', value: subregion});
            this.isLoading = true;
            var that = this;
            var result = [];
            this.noMorePages = false;
            this.lastVisibleResult = undefined;
           
            if (this.displayTextMap[subregion]) {
                subregion = this.displayTextMap[subregion];
                // cleanedRoute = this.displayTextMap[this.$refs["route-filter-find"].selectedModel[0]];
            }
            if (this.$debug) {console.log("*** Getting pages for subregion ", subregion);}
            this.currentQuery = this.$db.collection("pages").where("regions", "array-contains", subregion).orderBy("year", "desc").orderBy("added", "desc");
            this.$db.collection("pages").where("regions", "array-contains", subregion).orderBy("year", "desc").orderBy("added", "desc").limit(that.queryLimit).get()
                .then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        // doc.data() is never undefined for query doc snapshots
                        // console.log(doc.id, " => ", doc.data());
                        var dataAndId = doc.data();
                        dataAndId['id'] = doc.id;
                        if (!result.includes(doc.id)) {
                            result.push(dataAndId);
                        }
                    });
                    that.lastVisibleResult = querySnapshot.docs[querySnapshot.docs.length - 1];
                    if (!that.lastVisibleResult || querySnapshot.docs.length < that.queryLimit ) {
                        that.noMorePages = true;
                    }
                    that.resultPages = result;
                    that.showingSelected = true;
                    that.isLoading = false;
                })
                .catch(function(error) {
                    console.log("Error getting pages by subregion: ", error);
                    that.isLoading = false;
                });
            this.showingSelected = true;
        },

        fetchPagesBySite(siteDomain) {
            if (this.$debug) {console.log("DEBUG: In function fetchPagesBySite with input ", siteDomain);}
            var that = this;
            // this.clearFilters();
            this.isLoading = true;
            var result = [];
            this.noMorePages = false;
            this.lastVisibleResult = undefined;
            // var queryLimit = this.pageSize;
            // console.log(this.activeFilterCount);
            // if (this.activeFilterCount > 0) { //override pagination if filters are being used (hack for now because firebase sucks at tag filtering)
            //     queryLimit = 1000;
            // }
            // console.log(this.$refs["route-filter-find"].selectedModel[0]);
            console.log("getting pages for " + siteDomain);
            this.currentQuery = this.$db.collection("pages").where("site_domain", "==", siteDomain).orderBy("added", "desc");
            this.$db.collection("pages").where("site_domain", "==", siteDomain).orderBy("added", "desc").limit(that.queryLimit).get()
                .then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        // doc.data() is never undefined for query doc snapshots
                        // console.log(doc.id, " => ", doc.data());
                        var dataAndId = doc.data();
                        dataAndId['id'] = doc.id;
                        result.push(dataAndId);
                    
                    });
                    that.lastVisibleResult = querySnapshot.docs[querySnapshot.docs.length - 1];
                    if (!that.lastVisibleResult || querySnapshot.docs.length < that.queryLimit ) {
                        that.noMorePages = true;
                    }
                    that.resultPages = result;
                    // console.log(that.resultPages);
                    that.showingSelected = true;
                    // that.$refs["country-filter-find"].selectedModel = [];
                    this.setContinentInput("");
                    this.setRouteInput("");
                    this.setSubregionInput("");
                    this.setCountryInput("");
                    // that.$refs["rider-filter-find"].selectedModel = [];
                })
                .catch(function(error) {
                    console.log("Error getting pages by site: ", error);
                    that.isLoading = false;
                });
            this.showingSelected = true;
        },
     
        getRecentlyAdded() {

        // https://firebase.google.com/docs/functions/callable#web_2
        //    var functionResult = this.$firebase.functions().httpsCallable('getPages');
        //     functionResult({ text: "Helloooo cloud function" })
        //     .then((result) => {
                
        //         // Read result of the Cloud Function.
        //         var answer = result.data.result;
        //         console.log("************");
        //         console.log(answer);
        //     });

            if (this.$debug) {console.log("DEBUG: In function getRecentlyAdded");}
            var that = this;
            that.isLoading = true;
            var result = [];    
            this.details = undefined;
            this.noMorePages = false;
            this.lastVisibleResult = undefined;
            this.currentQuery = this.$db.collection("pages").orderBy("added", "desc");
            // var queryLimit = this.pageSize;
            // // console.log(this.getFilterCount() + " filters");
            // if (this.activeFilterCount > 0) { //override pagination if filters are being used (hack for now because firebase sucks at tag filtering)
            //     queryLimit = 1000;
            //     console.log(queryLimit);
            // }
            // console.log(queryLimit);
            this.$db.collection("pages").orderBy("added", "desc").limit(that.queryLimit).get()
                .then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        // doc.data() is never undefined for query doc snapshots
                        // console.log(doc.id, " => ", doc.data());
                        // result.push(doc.data());
                        var dataAndId = doc.data();
                        dataAndId['id'] = doc.id;
                        result.push(dataAndId);
                    
                    });
                    that.lastVisibleResult = querySnapshot.docs[querySnapshot.docs.length - 1];
                    if (!that.lastVisibleResult || querySnapshot.docs.length < that.queryLimit ) {
                        that.noMorePages = true;
                    }
                    that.resultPages = result;
                    that.showingSelected = false;
                    that.isLoading = false;
                    
                });
        },

        nextPage() {
            if (this.$debug) {console.log("DEBUG: In function nextPage");}
            var that = this;
            var result = [];  
            // var queryLimit = this.pageSize;
            //     if (this.activeFilterCount > 0) { //override pagination if filters are being used (hack for now because firebase sucks at tag filtering)
            //         queryLimit = 1000;
            //     }
            if (this.lastVisibleResult) {
                this.noMorePages = false;
                this.currentQuery.startAfter(this.lastVisibleResult).limit(that.queryLimit).get()
                .then(function(querySnapshot) {
                    querySnapshot.forEach(function(doc) {
                        // doc.data() is never undefined for query doc snapshots
                        // console.log(doc.id, " => ", doc.data());
                        // result.push(doc.data());
                        var dataAndId = doc.data();
                        dataAndId['id'] = doc.id;
                        result.push(dataAndId);
                    
                    });
                    // console.log("last");
                    that.lastVisibleResult = querySnapshot.docs[querySnapshot.docs.length - 1];
                    if (!that.lastVisibleResult || querySnapshot.docs.length < that.queryLimit ) {
                        that.noMorePages = true;
                    }
                    that.resultPages.push(...result);
                    // that.resultPages = [].concat(that.resultPages, result); // this is for loading more below
                    // that.resultPages = result; // this is for replacing results with next page
                    // that.showingSelected = false;
                    // console.log(that.$route.path);
                    // if (that.$route.path != '/d') {
                    //     that.$router.push({ path: '/d'});
                    // }
                });         

            } else {
                this.noMorePages = true;
            }
                  
           
        },

        loadTags() {
            var loadedAll = true;
            if (!this.initDataLoaded) {
                var that = this;

                // Replace later with just one copy loaded in parent
                //   var that = this;
                that.$db.collection("tags").doc("routes").get()
                    .then(function(doc) {
                        if (doc.exists){
                            that.routes = doc.data().routes;
                        }
                    
                    }).catch(function(error) {
                            console.error("Error finding routes: ", error);
                            loadedAll = false;
                    });

                that.$db.collection("tags").doc("ridertags").get()
                    .then(function(doc) {
                        if (doc.exists){
                            that.riderTags = doc.data().ridertags;
                        }
                    
                    }).catch(function(error) {
                            console.error("Error finding rider tags: ", error);
                            loadedAll = false;
                    });
            }
            if (loadedAll) {
                this.initDataLoaded = true;
            }

        },
      
        signOut() {
            this.$firebase.auth().signOut().then(function() {
            // Sign-out successful.
                location.reload();
            }).catch(function(error) {
            // An error happened.
            });
        },
        
        getCodeFromCountry(inputName) {
            for (const code in this.$countrymap) {
                if (this.$countrymap[code].toLowerCase() == inputName.toLowerCase()) {
                    return code;
                }
            }
            return "";
        },

        setCountryInput(countryname) {
            if (this.$debug) {console.log("DEBUG: In function setCountryInput: ", countryname);}
            // console.log(countryname);
            if (countryname && countryname != "") {
                const countrycode = this.getCodeFromCountry(countryname);
                this.selectedCountryCode = countrycode;
                this.$refs["country-filter-find"].selectedModel = [this.titleCase(countryname)];
            } else {
                this.$refs["country-filter-find"].selectedModel = [];
            }
            this.setSubregionInput("");
            
        },
        getCountryInput() {
            if (this.$refs["country-filter-find"] && this.$refs["country-filter-find"].selectedModel.length > 0) {
                return this.$refs["country-filter-find"].selectedModel[0];
            } else {
                return "";
            }
        },

        setContinentInput(continent) {
            if (this.$debug) {console.log("DEBUG: In function setContinentInput, setting to : ", continent);}
            console.log("current", this.selectedContinent, "next", continent);
            this.selectedContinent = continent;
        },
        getContinentInput() {
            return this.selectedContinent;
        },


        setRouteInput(route) {
            if (route && route != "") {
                this.$refs["route-filter-find"].selectedModel = [route];
            } else {
                this.$refs["route-filter-find"].selectedModel = [];
            }
        },
        getRouteInput() {
            if (this.$refs["route-filter-find"] && this.$refs["route-filter-find"].selectedModel.length > 0) {
                return this.$refs["route-filter-find"].selectedModel[0];
            } else {
                return "";
            }
        },
        setSubregionInput(subregionName) {
            if (this.$debug) {console.log("DEBUG: In function setSubregionInput, setting to : ", subregionName);}
            if (subregionName && subregionName != "") {
                this.$refs["subregion-filter-find"].selectedModel = [subregionName];
            } else {
                this.$refs["subregion-filter-find"].selectedModel = [];
            }
        },
        getSubregionInput() {
            if (this.$refs["subregion-filter-find"]  && this.$refs["subregion-filter-find"].selectedModel.length > 0) {
                return this.$refs["subregion-filter-find"].selectedModel[0];
            } else {
                return "";
            }
        },

    
        setStateFromRoute(route) {
            var that = this;
            if (this.$debug) {console.log("DEBUG: In function setStateFromRoute: ", route);}
            // console.log("ROute is ", route.params.route);
            var countryname = route.params.country;
            
            // console.log(this.$keyify(route.params.route));
            // var routename = this.$getParent('App').allRoutes[this.$keyify(route.params.route)].display_name;
            // console.log(routename);
            
            if (countryname != "" && countryname != undefined && !route.params.subregion) {
                var countrycode = this.getCodeFromCountry(route.params.country);
                this.setCountryInput(this.titleCase(countryname));
                this.handleCountrySearch(countrycode);
                this.activeTab = 1;
                // this.fetchPagesByCountry(countrycode);
            } else if (route.params.continent != "" && route.params.continent != undefined) {
                this.setContinentInput(this.titleCase(route.params.continent));
                this.handleContinentSearch(route.params.continent);
                this.activeTab = 0;
            } else if (route.params.route != "" && route.params.route != undefined) {
                // first get display name of route so we can use it to query pages
                var routename = route.params.route;
                this.$db.collection("routes").doc(this.$keyify(route.params.route)).get()
                    .then(function(doc) {
                        // todo: if change to storing routes by key instead of display name, need to change this part
                        if (doc.data().display_name) {
                            routename = doc.data().display_name;
                        }
                        that.setRouteInput(routename);
                        that.handleRouteSearch(routename);
                    }).catch(function(error) {
                        console.log("Error getting allRoutes: ", error);
                        that.setRouteInput(routename);
                        that.handleRouteSearch(routename);
                    });


                // this.setRouteInput(this.titleCase(route.params.route));
                // this.handleRouteSearch(this.titleCase(route.params.route));
                this.activeTab = 2;
            } else if (route.params.country && route.params.subregion) {           
                var countrycode = this.getCodeFromCountry(route.params.country);
                this.setCountryInput(route.params.country);
                // ETHAN'S DIRTY HACK - next line is also in handleCountrySearch
                this.fetchSubregionsByCountry(countrycode);
                this.setSubregionInput(this.titleCase(route.params.subregion));
                this.handleSubregionSearch(route.params.subregion);
                this.activeTab = 1;
            } else {
                this.getRecentlyAdded(); // todo: should probably go somewhere else
                this.setCountryInput("");
                this.setContinentInput("");
                this.setRouteInput("");
                this.setSubregionInput("");
                this.filteredHeading = "";
                this.activeTab = 0;
            }
            // filters
            // console.log("Query string params found: ", route.query);
            var filterCount = 0;
            if (route.query.surface) {
                this.selectedSurfaces = route.query.surface.split(",");
                filterCount = filterCount + 1;
                // console.log("Param ", route.query.surface.split(","), this.selectedSurfaces);
                // this.filterUpdated();
            }
            if (route.query.mood) {
                this.selectedMoods = route.query.mood.split(",");
                filterCount = filterCount + 1;
                // this.filterUpdated();
            }
            if (route.query.style) {
                this.selectedStyles = route.query.style.split(",");
                filterCount = filterCount + 1;
                // this.filterUpdated();
            }
            if (route.query.extras) {
                this.selectedExtras = route.query.extras.split(",");
                filterCount = filterCount + 1;
                // this.filterUpdated();
            }
            // console.log("looking at rider tags in url");
            // console.log(route.query.rider.split(","));
            if (route.query.rider && this.$refs["rider-tags-find"]) {
                // this.$refs["rider-tags-find"].selectedModel = route.query.rider.split(",");
                this.$refs["rider-tags-find"].setModel(route.query.rider.split(","));
                filterCount = filterCount + 1;
                // console.log("Applying rider tags");
                // console.log(this.$refs["rider-tags-find"].selectedModel);
                // this.filterUpdated();
            }
            if (filterCount > 0) {
                this.filterUpdated("urlparam");
            }
            // console.log("Scrolling");
            // if (route.query.scroll == "results") {
            //     var cancelScroll = this.$scrollTo('#results-title');
            //     var that = this;
            //     setTimeout(function() {
            //         let query = Object.assign({}, route.query);
            //         delete query.scroll;
            //         // that.$router.replace({ query });
            //         // console.log("removing query");
            //     }, 1000);
                
            // }
            
        },
        titleCase(str) {
            str = str.toLowerCase();
            var words = str.split(' ');
            var skipWords = ["to", "de", "la", "n", "'n"];
            for (var i = 0; i < words.length; i++) {
                if (!skipWords.includes(words[i])) {
                    words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1); 
                }
            }
            return words.join(' ');
        },
        initializePage() {
            if (this.$debug) {console.log("In function initializePage with isMounted ", this.isMounted);}
            var that = this;
            this.isLoading = true;

            if (!that.isMounted && that.$getParent('App').user) {
                console.log("Loading stuff and parsing URL");
                that.loadTags();
                // that.setStateFromRoute(that.$route);
                that.isMounted = true;
            }

            this.$firebase.auth().onAuthStateChanged(function(user) {
                if (!that.isMounted && user) {
                    console.log("Loading stuff and parsing URL");
                    that.loadTags();
                    // that.setStateFromRoute(that.$route);
                    that.isMounted = true;
                }
            });
        },

        handleCountrySearch(code) {
            if (this.$debug) { console.log("DEBUG: in handleCountrySearch with val ", code);}
            this.fetchPagesByCountry(code); // make this return promise
            this.filteredHeading = this.$countrymap[code];
            this.loadItemDetails(this.$countrymap[code], 'countries');
            
            // get subregions, if any
            this.fetchSubregionsByCountry(code);

            this.setContinentInput("");
            this.setRouteInput("");
            this.setSubregionInput("");
            this.clearFilters();
        },
        handleSubregionSearch(val) {
            if (this.$debug) { console.log("DEBUG: in handleSubregionSearch with val ", val);}
            this.fetchPagesBySubregion(this.titleCase(val)); // make this return promise
            this.filteredHeading = this.getCountryInput() + ": " + this.titleCase(val);
    
            this.loadItemDetails(val, 'regions');
            
            this.setContinentInput("");
            this.setRouteInput("");
        },
        handleRouteSearch(val) {
            if (this.$debug) { console.log("DEBUG: in handleRouteSearch with val ", val);}
            this.fetchPagesByRoute(val); // make this return promise
            this.filteredHeading = val;

            this.loadItemDetails(val, 'routes');
            this.setContinentInput("");
            this.setCountryInput("");
            this.setSubregionInput("");
            this.clearFilters();
        },
        handleContinentSearch(val) {
            if (this.$debug) { console.log("DEBUG: in handleContinentSearch with val ", val);}
            this.fetchPagesByContinent(this.titleCase(val)); // make this return promise
            this.filteredHeading = this.titleCase(val);

            this.loadItemDetails(val, 'continents');

            this.setCountryInput("");
            this.setRouteInput("");
            this.setSubregionInput("");
            this.clearFilters();
        },

           
    },
    beforeRouteUpdate(to, from, next) {
        console.log("beforeRouteUpdate ", from.params, to.params);
        // this.setStateFromRoute(to);
        var newparams = {};
        var changed = false;
        console.log(this.displayTextMap);
        for (var key in to.params) {
            console.log(key);
            var val = to.params[key];
            if (this.displayTextMap[val]) {
                console.log("display mapping found", this.displayTextMap[val]);
                newparams[key] = this.displayTextMap[val];
                changed = true;
            } else {
                newparams[key] = val;
            }
        }
        if (changed) {
            this.$router.push({ name: to.name, params: newparams }).catch(failure => {
                            });
        } else {
            this.setStateFromRoute(to);
            next();
        }
        

        // this.$forceUpdate();
        // this.setStateFromRoute();
        // next();
        // this.setStateFromRoute();
    },
    beforeRouteEnter(to, from, next) {
        console.log("beforeRouteEnter with to: ", to);
        
        next(vm => {
            // vm.isMounted = false;
            // vm.initializePage();
            // vm.setStateFromRoute
            vm.setStateFromRoute(to);
        });
        // this.setStateFromRoute();
    },
    mounted() {
        
        this.$nextTick(function () {
            if (this.$debug) {
                console.log("DEBUG: In MOUNTED() with user ", this.$firebase.auth().currentUser);
            } 
            if (this.$firebase.auth().currentUser) {
                // console.log("In mounted with user ", this.$firebase.auth().currentUser.displayName,  " and isMounted = ", this.isMounted);
            } else {
                // console.log("In mounted with user NULL and mounted = ", this.isMounted);
            }
            this.initializePage();

            if (this.$route.query.scroll == "results") {
                var cancelScroll = this.$scrollTo('#results-title');
                var that = this;
                let query = Object.assign({}, that.$route.query);
                delete query.scroll;
                that.$router.replace({ query });                
            }

            // ADD WATCHERS. Note, filter watchers are up at the top
            this.$watch(
                () => {
                    return this.$refs['country-filter-find'].selectedModel
                },
                (val) => {
                    console.log("In country watcher, country changed:", val);
                    
                    if (val.length > 0) {
                        var country = val[0];
                        if (country.name) { country = country.name; } // object from taginput
                        // this.handleCountrySearch(val[0]);
                        var newPath = "";
                        if (this.getSubregionInput() != "") {
                            newPath = '/countries/' + this.getCountryInput() + "/" + this.getSubregionInput();
                        } else {
                            newPath = '/countries/' + country;
                        }
                        // var newPath = '/countries/' + country;
                        this.$router.push({ path: newPath}).catch(failure => { });
                        
                        // }
                    } else {
                        this.subregions = [];
                        this.setSubregionInput("");
                    }
                    // this.handleQueryChange(val[0], "country");
                    // this.fetchResultsByType(val[0]);
                }
            );
            this.$watch(
                () => {
                    return this.$refs['subregion-filter-find'].selectedModel
                },
                (val) => {
                    console.log("****subregion changed:", val);
                    if (val.length > 0) {
                        // this.handleSubregionSearch(val[0]);
                        var newPath = '/countries/' + this.getCountryInput() + "/" + this.getSubregionInput();
                        
                        this.$router.push({ path: newPath}).catch(failure => {
                            // console.log("Error pushing route", failure);
                        });
                        
                    } else {
                        if (this.getCountryInput() != "") {
                            var newPath = '/countries/' + this.getCountryInput();
                            this.$router.push({ path: newPath}).catch(failure => { });
                        }
                    }
                }
            );
            this.$watch(
                () => {
                    return this.$refs['route-filter-find'].selectedModel
                },
                (val) => {
                    console.log("In route watcher, route changed:", val);
                    if (val.length > 0) {
                        // this.handleRouteSearch(val[0]);
                        var newPath = '/routes/' + val[0];
                        if (this.$route.path != newPath) {
                            this.$router.push({ path: newPath}).catch(failure => {
                            });
                        }
                    }

                }
            );
            this.$watch( // UNFINISHED
                () => {
                    return this.$refs['rider-tags-find'].selectedModel
                },
                (val) => {
                    console.log("rider tags changed:", val);
                }
            );
            this.$watch(
                () => {
                    return this.selectedContinent
                },
                (val) => {
                    console.log("In continent watcher, continent changed:", val);
                    if (val != "") {
                        // this.handleContinentSearch(val);
                        var newPath = '/continents/' + encodeURIComponent(val);
                        // if (this.$route.path != newPath) {
                            this.$router.push({ path: newPath}).catch(failure => {
                                console.log(failure);
                            });
                        // }
                    }
                }
            );

            // this.$watch(
            //     this.$refs['country-filter-find'].selectedModel,
            //     (new_value, old_value) => {
            //         //execute your code here
            //         console.log("&&&&&&&&&&");
            //     }
            //     );
            
            // console.log("Mounted: Query string params found: ", this.$route);
            // console.log("Signing in");
            // console.log(this.$firebase.auth().currentUser);
            // console.log(this.user);
            
            // var that = this;
            // this.isLoading = true;

            // if (!that.isMounted && that.$getParent('App').user) {
            //     console.log("Loading stuff and parsing URL");
            //     that.loadTags();
            //     that.setStateFromRoute();
            //     that.isMounted = true;
            // }

            // this.$firebase.auth().onAuthStateChanged(function(user) {
            //     if (!that.isMounted && user) {
            //         console.log("Loading stuff and parsing URL");
            //         that.loadTags();
            //         that.setStateFromRoute();
            //         that.isMounted = true;
            //     }
            // });
        });
    },
    metaInfo() {
        var counts = "Browse " + this.$getTotals()._posts + " posts from " + this.$getTotals()._sites + " riders in " + this.$getTotals()._countries + " countries, and growing fast!";
        var title = "Discover Bike Touring and Bikepacking Blogs";
        var description =  this.filteredHeading + " | Find bicycle touring and bikepacking blogs to inspire and inform your next bike trip.";
        if (this.filteredHeading != "") {
            title = this.filteredHeading + " Bike Touring and Bikepacking Blogs";
        }
        var modified = this.getMostRecentDate();
        return {
            // title: 'Find Bike Blogs | Bike Sleep Bike',
            title: title,
            titleTemplate: '%s | BikeSleepBike',
            description: description,
            meta: [
                { name: "og:title", property: "og:title", content: title  },
                { name: "description", content: description  },
                { name: "og:description", property: "og:description", content: description  },
                { name: "og:url", property: "og:url", content: "https://bikesleepbike.com" + this.$route.path}
            ]
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 @media screen and (min-width: 1400px) {

     


    .explore-here {
        position:absolute;
        background-image:url("https://bikesleepbike.com/BSB-explore-here.png");
        height: 150px;
        width: 200px;
        background-repeat: no-repeat;
        left: -180px;
        top:20px
    }
}
   
   
    .taginput.control small.help.counter {
        display:none !important;
        color:#fafafa !important;
    }
    .taginput.wrap {
        margin-top:5px;
    }
    .page-card {
        margin-bottom:40px !important;
        text-align: left;
        border: 1px solid #e6e6e6;
    }
    .find-trips {
        text-align:left;
        margin-top: 20px;
    }
    .field {
        margin-top:20px;
    }
    .margin-bottom {
        margin-bottom:10px;
    }
    .tag {
        margin-right:3px;
        margin-bottom:3px;
    }
    /* .page-card {
        padding:0;
        margin:0;
        margin-bottom: 30px;
    }
    .page-card .image-column {
        padding:0;
        margin:0;
    }
    .page-card .text-column {
        padding:20px 30px;
    }
    @media screen and (max-width: 789px) { 
        .page-card .text-column {
            padding:20px;
        }
    }
    .page-card-columns {
        margin:0;
    } */
    .help {
        display:none !important;
        color:#fafafa !important;
    }
    .image-column {
        background-size: cover;
        min-height:200px;
    }
    .find-trips, .add-trips {
    max-width:1000px;
  }
   html {
    background-color: #fafafa;
  }
  /* .admin-btn {
      position:absolute;
      top:0;
      right:0;
  } */
  .tab-box {
      background-color:white;
      padding:40px 30px;
      margin:-38px -16px -20px -16px;
      border:1px solid #dbdbdb;
      border-top:none;
      border-radius: 0 0 5px 5px;
      text-align: center;
  }
  .tab-box-header {
      font-weight: bold;
      font-size: 20px;
      display: none;
  }
  .find-banner {
      background-size:contain;
      background-repeat:no-repeat;
      background-image:url("https://bike-trip-directory.web.app/banner.png");
  }
  .find-banner2 {
      background-size:contain;
      background-repeat:no-repeat;
      background-image:url("https://bike-trip-directory.web.app/banner.png");
      
  }
  .find-trips .icon.is-medium i {
      font-size:1em !important;
  }
  .continent-chooser .radio.button span {
      font-size:20px;
  }
  /* .image-placeholder {
      position: absolute;
      background-image: url(https://bikesleepbike.com/bsb_placeholder.jpg);
      width:200px;
      height:100%;
      z-index: -1;
  }  */
  .intro {
      background-color: white;
      padding: 20px;
  }
  .autofill-options a {
    margin-left: 8px;
      
  }
  .autofill-options {
    margin-top: 10px;
  }
 .filter-toggle.visible {
     display:inline !important;
 }
 .continent-chooser .control {
     min-width:300px;
 }
 .continent-chooser2 .control {
     /* min-width:200px; */
 }
  
</style>

<style>
    .find-trips .taginput-container:not(.is-focusable),
    .find-trips2 .taginput-container:not(.is-focusable) {
        justify-content: center !important;
    }
    .find-trips .help.counter, .find-trips2 .help.counter {
        display:none;
    }
    @media screen and (max-width: 789px) {
        .title.is-2,
        .title.is-3,
        .results-title {
            font-size: 1.8rem;
        }
    }

    .filter-box.shown {
        display:block !important;
    }
    .hidden {
        display:none;
    }
</style>


<!-- 
TODO
- disallow dup urls - if already exists, offer option to edit instead (change merge to false)
- strip after ?
- extract human readable key from url
- validate url
- tags for solo etc, surface, language
- let people add new tags for route
- states for US


 -->



// WEBPACK FOOTER //
// src/components/FindTrip.vue